import { cn } from '../../lib/cn';
import type { IncidentVulnRow } from '../../securitygovernance/framework';

type Props = { items?: IncidentVulnRow[] };

export function IncidentVulnerabilityPanel({ items = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item) => (
        <div key={`${item.category}-${item.item}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{item.category}</p>
          <p className="text-sm font-medium">{item.item}</p>
          <div className="mt-1 flex items-center gap-2">
            <span className="text-lg font-semibold text-slate-900 dark:text-slate-100">{item.count}</span>
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              item.status === 'patched' || item.status === 'contained' || item.status === 'within_sla' || item.status === '96%'
                ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
                : 'bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300',
            )}>
              {item.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
